import { type ActionItem } from 'shared/ui'
import { uiStore } from 'shared/store/uiStore'
import { SurveysPath } from 'entities/ExportRouters'

export const duplicate = (id: number): ActionItem => {
  return {
    text: 'Duplicate',
    icon: 'copy',
    onAction: () => {
      uiStore.changeRoute({
        path: SurveysPath.create,
        options: {
          state: {
            response: { id: id },
            isDuplicate: true,
          },
        },
      })
    },
  }
}
